import React, { useState } from "react";
import styled from "styled-components";

export default function SettingInput(props) {
  const { value, setValue, placeholder, isTimeType, isReadOnly = false } = props;

  const [timeBorder, setTimeBorder] = useState('');

  function getTimeDisplayValue() {
    if (value === '' || value === null || value === undefined) return '';
    if (typeof value === 'number') return `${String(value).padStart(2, '0')}:00`;
    return String(value);
  }

  function handleClick(e) {
  }

  function handleChange(e) {
    let regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 매칭하는 정규식
    let result = e.target.value.replace(regex, "");	// 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경

    if (e.target.value === '') setValue(0);
    else setValue(parseInt(result));
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  // 시간 입력 (HH:MM) — 숫자만 추출해 위치 기준으로 재조립 + 시≤23·분≤59 클램핑 //
  function handleChangeTime(e) {
    const digits = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);

    let hour = digits.slice(0, 2);
    let minute = digits.slice(2, 4);

    if (hour.length === 2 && parseInt(hour, 10) > 23) hour = '23';
    if (minute.length === 2 && parseInt(minute, 10) > 59) minute = '59';

    let formatted = hour;
    if (digits.length > 2) formatted += ':' + minute;

    setValue(formatted);
  }

  function handleFocusTime() {
  }

  function handleBlurTime() {
    setTimeBorder('');
  }

  return (
    <InputView border={isReadOnly ? 'none' : (isTimeType ? timeBorder : '')}>
      <Input
        placeholder={placeholder}
        value={isTimeType ? getTimeDisplayValue() : value}
        onClick={handleClick}
        onChange={isTimeType ? handleChangeTime : handleChange}
        onFocus={isTimeType ? handleFocusTime : handleFocus}
        onBlur={isTimeType ? handleBlurTime : handleBlur}/>
    </InputView>
  );
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 5px;

  box-sizing: border-box;
  width: 100%;
  height: 100%;

  border: ${props => props.border ? props.border : `1px solid ${props.theme.line}`};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const Input = styled.input`
	font-family: NotoSansKR-Medium;
	font-size: 14px;
	line-height: 20px;
  text-align: center;

  padding: 0;

  width: 100%;
  height: 100%;

	outline: none;
  border: 0px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

	::placeholder {
    color: ${props => props.theme.line};
	}

  transition: all 0.3s ease-in-out;
`;
